import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import en from "./en"
import zh from "./zh"

const LANGUAGE_KEY = "preferred_language"

const savedLanguage = localStorage.getItem(LANGUAGE_KEY) || "zh"

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(LANGUAGE_KEY, lng)
})

export default i18n
